import { Dimensions, StyleSheet } from "react-native";

const styles = StyleSheet.create({
  contentItem: {
    alignItems: "center",
    justifyContent: "space-evenly",
    width: "100%",
    minHeight: 90,
    borderRadius: 8,
    padding: 10,
    flexDirection: "row",
    marginBottom: 10,
    borderWidth: 0.5,
    borderColor: "#077A97",
    marginTop: 10,
    flexWrap: "wrap",
  },
  img: {
    width: 20,
    height: 20,
    tintColor: "#077A97",
  },
  imgModal: {
    width: 52,
    height: 50,
    marginHorizontal: "auto",
  },

  titleTransactions: {
    fontSize: 12,
  },
  infosTransactions: {
    fontSize: 12,
  },
  dateTransactions: {
    fontSize: 12,
  },

  iconGo: {
    position: "absolute",
    right: 10,
    marginTop: 20,
  },
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 22,
  },
  modalCenteredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  closeModal: {
    padding: 10,
    width: "80%",
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginVertical: 20,
    marginHorizontal: "auto",
  },

  hrLine: {
    height: 0.2,
    width: "100%",
    borderWidth: 0.2,
    marginTop: 10,
    marginBottom: 10,
    borderColor: "#077A97",
  },

  share: {
    marginRight: "auto",
    marginLeft: -10,
    marginTop: -5,
  },
  modalView: {
    width: "auto",
    marginTop: 20,
    backgroundColor: "#ffffff",
    borderRadius: 8,
    paddingHorizontal: 35,
    paddingVertical: 15,
    alignItems: "center",
    overflow: "hidden",
    shadowOpacity: 0.2,
    shadowColor: "#000",
    shadowRadius: 0,
    shadowOffset: {
      width: 0,
      height: 0,
    },
  },
  button: {
    borderRadius: 20,
    padding: 10,
    elevation: 2,
  },
  idContainer: {
    marginHorizontal: -35,
    marginBottom: -25,
    marginTop: 20,
  },
  modalTitle: {
    textTransform: "uppercase",
    color: "#077A97",
    fontWeight: "bold",
    textAlign: "center",
    fontSize: 16,
    marginBottom: 8,
  },
  modalText: {
    width: "100%",
    backgroundColor: "#fff",
    marginVertical: 10,
    textAlign: "left",
    alignContent: "center",
  },
  whiteText: {
    color: "white",
    fontSize: 12,
  },
  boldText: {
    fontWeight: "bold",
  },
  modalTextDate: {
    width: "100%",
    color: "#000000",
    fontSize: 12,
    marginVertical: 10,
    textAlign: "center",
    alignContent: "center",
  },
  blueBackground: {
    borderWidth: 1,
    color: "#ffffff",
    marginLeft: -15,
  },
  action_buttons_container: {
    paddingHorizontal: 10,
    marginTop: 10,
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginBottom: 5,
  },
  action_button: {
    padding: 10,
    borderRadius: 4,
    marginRight: 15,
    backgroundColor: "#077A97",
  },
  action_button_text: {
    fontWeight: "bold",
    color: "#FFF",
    textAlign: "center",
  },

  btnInfo: {
    minWidth: 120,
    height: 34,
    paddingHorizontal: 6,
    paddingVertical: 4,
    borderRadius: 4,
    borderColor: "#077A97",
    borderWidth: 0.5,
    backgroundColor: "#077A97",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    marginRight: 10,
  },

  certificateHeaders: {
    textTransform: "uppercase",
    fontSize: 14,
    color: "#077A97",
  },

  columnContainer: {
    flexDirection: "column",
    alignItems: "center",
  },

  ativoImgRowContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },

  labelRows: {
    justifyContent: "space-between",
    flexDirection: "row",
  },
  gpxTitle: {
    textAlign: "center",
    fontSize: 14,
    fontWeight: "bold",
    color: "#000000",
  },

  gpxCnpj: {
    fontSize: 14,
    color: "#000000",
    textAlign: "center",
  },

  txtFecharModal: {
    color: "#FFF",
    textTransform: "uppercase",
  },
});

export default styles;
